import { Input } from "components/Form/components/Input/Input";
import { FormComponentProps } from "../FormComponentProps";
import { Markdown } from "./Markdown";
import "./Markdown.scss";

export const MarkdownFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        <Markdown markdownString={fieldProps?.markdown ? fieldProps?.markdown : input.value} />
    </Input>
);
